<template>
  <div class="px-4 relative">
    <!-- Left Glow -->
    <div class="absolute pointer-events-none left-0 top-56 sm:-top-10 max-w-[240px] sm:max-w-max">
      <img
        src="/img/pages/welcome/banner-left-glow.png"
        alt="left-glow"
      >
    </div>
    <!-- Right Glow -->
    <div class="absolute pointer-events-none right-0 -top-16">
      <img
        src="/img/pages/welcome/banner-right-glow.png"
        alt="left-glow"
      >
    </div><!-- banner -->
    <section
      class="max-w-screen-xl pt-12 md:pt-20 px-5 xl:px-0 mx-auto text-center"
    >
      <!-- Banner title -->
      <h1
        class="max-w-5xl text-3xl sm:text-5xl dark:text-white lg:text-7xl font-semibold mt-6 pb-11 mx-auto"
      >
        Beautiful Advanced Forms made for
        <object
          data="/img/pages/welcome/blocks.svg"
          type="image/svg+xml"
          class="inline mx-2 sm:mx-4 w-12 sm:w-auto"
        />
        Airtable
      </h1>

      <!-- Banner action -->
      <v-button
        v-track.create_form_click
        class="inline-block group"
        :to="{ name: 'register' }"
      >
        Create form
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="w-4 h-4 inline -mt-[2px] transition-transform group-hover:translate-x-1"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"
          />
        </svg>
      </v-button>
      <span class="block mt-2 text-sm"> Get started for free </span>
    </section>

    <!-- Our products  -->
    <section class="pt-12 sm:pt-16 px-5 xl:px-0 mx-auto max-w-[900px]">
      <h2 class="text-center mb-6 text-lg">
        Our products are trusted by 100+ companies
      </h2>
      <!-- Product Trusted Logos -->
      <div class="flex flex-wrap items-center justify-center gap-4">
        <div
          class="rounded-full shine dark:bg-gradient-core py-2 px-6 flex items-center justify-center"
        >
          <img
            alt="Logo Harvard"
            class="max-w-[100px]"
            src="/img/customers/harvard.png"
          >
        </div>
        <div
          class="rounded-full shine dark:bg-gradient-core py-2 px-6 flex items-center justify-center"
        >
          <img
            alt="Logo Hyundai"
            class="max-w-[100px]"
            src="/img/customers/hyundai.png"
          >
        </div>
        <div
          class="rounded-full shine dark:bg-gradient-core py-2 px-6 flex items-center justify-center"
        >
          <img
            alt="Logo Yale"
            class="max-w-[100px]"
            src="/img/customers/yale.png"
          >
        </div>
        <div
          class="rounded-full shine dark:bg-gradient-core py-2 px-6 flex items-center justify-center"
        >
          <img
            alt="Logo SciencesPo"
            class="max-w-[100px]"
            src="/img/customers/sciencespo.png"
          >
        </div>
      </div>
    </section>

    <!-- About AirFormTable  -->
    <section
      class="max-w-screen-xl mt-20 pt-14 sm:pt-20 md:pt-32 px-5 xl:px-0 mx-auto"
    >
      <div class="max-w-[900px] text-center mx-auto">
        <p
          class="text-blue-500 flex justify-center items-center text-lg mb-2 gap-1"
        >
          <svg
            class="inline w-5 h-5 -mt-1"
            viewBox="0 0 17 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.096 2.29254C14.9624 2.16688 14.7956 2.077 14.6128 2.03218C14.43 1.98736 14.2378 1.98921 14.0561 2.03754H14.0461L1.30009 5.67754C1.09261 5.7337 0.908229 5.84802 0.771499 6.00526C0.634769 6.16251 0.552179 6.35523 0.534728 6.55776C0.517276 6.76029 0.565791 6.96301 0.673812 7.13894C0.781833 7.31487 0.944235 7.45565 1.13939 7.54254L6.82509 10.0769L9.51787 15.4282C9.60288 15.5995 9.73822 15.7444 9.90789 15.8458C10.0776 15.9471 10.2745 16.0006 10.4754 16C10.506 16 10.5365 15.9988 10.5671 15.9963C10.7815 15.98 10.9855 15.9023 11.1517 15.7737C11.3179 15.6451 11.4383 15.4718 11.4968 15.2769L15.3616 3.28067C15.3616 3.27754 15.3616 3.27442 15.3616 3.27129C15.4136 3.10065 15.4165 2.92004 15.3698 2.74803C15.3231 2.57602 15.2286 2.41881 15.096 2.29254ZM10.4814 14.9907L10.4781 14.9994L7.86435 9.80629L11.0014 6.85317C11.0968 6.75864 11.1492 6.63276 11.1474 6.50238C11.1457 6.372 11.0899 6.24743 10.9919 6.15523C10.8939 6.06303 10.7616 6.01049 10.623 6.00882C10.4845 6.00715 10.3508 6.05648 10.2503 6.14629L7.11263 9.09879L1.59427 6.63879H1.60357L14.3443 3.00004L10.4814 14.9907Z"
              fill="#275DEA"
            />
          </svg>
          Introducing AirFormTable
        </p>
        <h3
          class="mb-6 text-3xl md:text-4xl lg:text-[64px] font-bold md:!leading-[1.2] tracking-[-2.56px]"
        >
          All the features you've been missing in your forms
        </h3>
        <p
          class="text-lg px-4 text-gray-500 dark:text-white tracking-[-0.28px]"
        >
          AirFormTable lets you build the most advanced forms and collect the
          submissions directly in your AirTable bases instantly.
        </p>
      </div>

      <div
        v-for="(item, index) in killerFeatures"
        :key="item.title"
        class="grid grid-cols-1 md:grid-cols-2 mt-14 sm:mt-20 md:mt-32 gap-10 lg:gap-20 items-center"
      >
        <div :class="[index % 2 == 0 ? 'order-1 md:order-2' : 'order-1']">
          <p class="!text-blue-500 flex gap-1 text-lg">
            <svg
              class="w-6 h-6"
              viewBox="0 0 22 23"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g id="Sparkle">
                <path
                  id="Vector"
                  d="M16.9796 11.5911L12.5444 9.95828L10.9115 5.51961C10.8148 5.25692 10.6399 5.03022 10.4103 4.87008C10.1807 4.70995 9.90755 4.62408 9.62763 4.62408C9.34772 4.62408 9.07454 4.70995 8.84495 4.87008C8.61536 5.03022 8.44042 5.25692 8.34373 5.51961L6.7092 9.95313L2.27052 11.5859C2.00784 11.6826 1.78113 11.8576 1.621 12.0872C1.46086 12.3167 1.375 12.5899 1.375 12.8698C1.375 13.1498 1.46086 13.4229 1.621 13.6525C1.78113 13.8821 2.00784 14.0571 2.27052 14.1538L6.70318 15.7969L8.33599 20.233C8.43269 20.4957 8.60763 20.7224 8.83722 20.8825C9.0668 21.0426 9.33998 21.1285 9.6199 21.1285C9.89982 21.1285 10.173 21.0426 10.4026 20.8825C10.6322 20.7224 10.8071 20.4957 10.9038 20.233L12.5366 15.7977L16.9753 14.1649C17.238 14.0682 17.4647 13.8933 17.6248 13.6637C17.785 13.4341 17.8708 13.1609 17.8708 12.881C17.8708 12.6011 17.785 12.3279 17.6248 12.0983C17.4647 11.8687 17.238 11.6938 16.9753 11.5971L16.9796 11.5911ZM12.0648 14.5078C11.879 14.576 11.7103 14.6838 11.5704 14.8238C11.4304 14.9637 11.3226 15.1324 11.2544 15.3182L9.62162 19.7405L7.99224 15.3148C7.924 15.13 7.81653 14.9621 7.67723 14.8228C7.53793 14.6835 7.3701 14.5761 7.18529 14.5078L2.76295 12.875L7.18529 11.2422C7.3701 11.1739 7.53793 11.0665 7.67723 10.9272C7.81653 10.7879 7.924 10.62 7.99224 10.4352L9.62506 6.01289L11.2579 10.4352C11.3261 10.621 11.4339 10.7897 11.5738 10.9297C11.7137 11.0696 11.8825 11.1774 12.0683 11.2456L16.4906 12.8784L12.0648 14.5078ZM12.3751 3.9375C12.3751 3.75516 12.4475 3.5803 12.5764 3.45136C12.7054 3.32243 12.8802 3.25 13.0626 3.25H14.4376V1.875C14.4376 1.69266 14.51 1.5178 14.6389 1.38886C14.7679 1.25993 14.9427 1.1875 15.1251 1.1875C15.3074 1.1875 15.4823 1.25993 15.6112 1.38886C15.7401 1.5178 15.8126 1.69266 15.8126 1.875V3.25H17.1876C17.3699 3.25 17.5448 3.32243 17.6737 3.45136C17.8026 3.5803 17.8751 3.75516 17.8751 3.9375C17.8751 4.11984 17.8026 4.2947 17.6737 4.42364C17.5448 4.55257 17.3699 4.625 17.1876 4.625H15.8126V6C15.8126 6.18234 15.7401 6.3572 15.6112 6.48614C15.4823 6.61507 15.3074 6.6875 15.1251 6.6875C14.9427 6.6875 14.7679 6.61507 14.6389 6.48614C14.51 6.3572 14.4376 6.18234 14.4376 6V4.625H13.0626C12.8802 4.625 12.7054 4.55257 12.5764 4.42364C12.4475 4.2947 12.3751 4.11984 12.3751 3.9375ZM21.3126 8.0625C21.3126 8.24484 21.2401 8.4197 21.1112 8.54864C20.9823 8.67757 20.8074 8.75 20.6251 8.75H19.9376V9.4375C19.9376 9.61984 19.8651 9.79471 19.7362 9.92364C19.6073 10.0526 19.4324 10.125 19.2501 10.125C19.0677 10.125 18.8929 10.0526 18.7639 9.92364C18.635 9.79471 18.5626 9.61984 18.5626 9.4375V8.75H17.8751C17.6927 8.75 17.5179 8.67757 17.3889 8.54864C17.26 8.4197 17.1876 8.24484 17.1876 8.0625C17.1876 7.88016 17.26 7.7053 17.3889 7.57636C17.5179 7.44743 17.6927 7.375 17.8751 7.375H18.5626V6.6875C18.5626 6.50516 18.635 6.3303 18.7639 6.20136C18.8929 6.07243 19.0677 6 19.2501 6C19.4324 6 19.6073 6.07243 19.7362 6.20136C19.8651 6.3303 19.9376 6.50516 19.9376 6.6875V7.375H20.6251C20.8074 7.375 20.9823 7.44743 21.1112 7.57636C21.2401 7.7053 21.3126 7.88016 21.3126 8.0625Z"
                  fill="currentColor"
                />
              </g>
            </svg>
            <span v-html="item.subtitle" />
          </p>
          <h3
            class="text-3xl md:text-4xl my-2 md:!leading-[1.2] lg:text-5xl xl:text-[52px] font-bold tracking-[-2.56px]"
            v-html="item.title"
          />
          <p
            class="text-lg text-grey max-w-[530px]"
            v-text="item.text"
          />
        </div>
        <div
          :class="[index % 2 == 0 ? 'order-2 md:order-1' : 'order-2']"
          class="relative max-w-md mx-auto md:ml-auto md:me-0"
        >
          <video
            class="w-full rounded-3xl shadow-lg mx-auto mb-4"
            autoplay
            loop
            muted
          >
            <source
              :src="'/img/pages/welcome/' + item.video"
              type="video/mp4"
            >
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
    </section>

    <!-- Services (...and more) -->
    <section class="max-w-screen-xl pt-20 md:pt-40 px-5 xl:px-0 mx-auto">
      <div class="max-w-[900px] text-center mx-auto">
        <h3
          class="mb-6 text-3xl md:text-4xl lg:text-[4rem] font-bold md:!leading-[1.2]"
        >
          ...and more
        </h3>
        <p class="text-lg px-3 text-grey">
          AirFormTable lets you build the most advanced forms and collect the
          submissions directly in your AirTable bases instantly.
        </p>
      </div>
      <div class="grid grid-cols-1 md:grid-cols-3 gap-7 mt-12 md:gap-4">
        <div
          v-for="item in [{
                            title: 'Unlimited number of records',
                            description:
                              'Because no one know in advance how many submissions they\'ll get',
                            img: 'card1-img.png',
                            img_top: true,
                            img_class: 'group-hover:-rotate-6 group-hover:scale-105',
                          },
                          {
                            title: 'Built-in analytics',
                            description: 'Automatically track form views and submissions',
                            img: 'card2-img.png',
                            img_top: false,
                            img_class: 'ml-4 group-hover:scale-105 group-hover:rotate-3',
                          },
                          {
                            title: 'Multi-page forms',
                            description:
                              'Show what\'s important by cutting down your form in different steps',
                            img: 'card3-img.png',
                            img_top: true,
                            img_class: 'ml-4 group-hover:-rotate-6 group-hover:scale-105',
                          },
                          {
                            title: 'File uploader',
                            description:
                              'Allow recipients to upload files up to 20 MB directly from your forms',
                            img: 'card4-img.png',
                            img_top: false,
                            img_class:
                              'ml-4 -mt-10 w-sm group-hover:-rotate-6 group-hover:scale-95 -translate-x-10 translate-y-10',
                          },
                          {
                            title: 'Form logic',
                            description:
                              'Make your form smart by showing and hiding fields based on pre-definied conditions',
                            img: 'card5-img.png',
                            img_top: true,
                            img_class: 'ml-4 group-hover:rotate-6 group-hover:scale-105',
                          },
                          {
                            title: 'Multiple integrations',
                            description:
                              'Get email and Slack notifications and use Webhooks to create automations with your form submissions.',
                            img: 'card6-img.png',
                            img_top: false,
                            img_class:
                              'ml-4 group-hover:scale-105 group-hover:-translate-x-4 group-hover:-translate-y-4 group-hover:rotate-3',
                          },
                          {
                            title: 'Password-gated access',
                            description:
                              'Request a numeric or alphanumeric password to access your form',
                            img: 'card7-img.png',
                            img_top: true,
                            img_class:
                              'ml-4 group-hover:scale-105 group-hover:translate-x-6 group-hover:rotate-3',
                          },
                          {
                            title: 'Accept payments',
                            description:
                              'Collect payments from anyone to schedule appointments or unlock content',
                            img: 'card8-img.png',
                            img_top: false,
                            img_class: 'ml-4 group-hover:scale-105 group-hover:-rotate-3',
                            coming_soon: true,
                          },
                          {
                            title: 'AI-powered form builder',
                            description:
                              'Let the power of AI ask the right questions for all your purposes in just a few seconds',
                            img: 'card9-img.png',
                            img_top: true,
                            img_class:
                              'ml-4 group-hover:scale-105 group-hover:rotate-6 group-hover:translate-y-5',
                            coming_soon: true,
                          },
          ]"
          :key="item.title"
          class="bg-gradient-white dark:bg-gradient-core flex shine flex-col justify-between rounded-2xl overflow-hidden relative group"
        >
          <template v-if="item.img_top">
            <img
              class="mx-auto z-20 w-full hidden dark:block transition-transform"
              :class="item.img_class"
              :src="'/img/pages/welcome/' + item.img"
              alt="card"
            >
            <img
              class="mx-auto z-20 w-full dark:hidden transition-transform"
              :class="item.img_class"
              :src="'/img/pages/welcome/light-' + item.img"
              alt="card"
            >
          </template>
          <div class="p-7 lg:p-10">
            <span
              v-if="item.coming_soon"
              class="py-1 px-2 mb-2 text-white text-xs rounded-3xl bg-blue-600 dark:bg-gradient-core inline-block"
            >Coming soon</span>
            <h5
              class="mb-1 dark:text-white text-lg font-bold"
              v-text="item.title"
            />
            <p
              class="text-sm text-gray-500 dark:text-white"
              v-text="item.description"
            />
          </div>
          <template v-if="!item.img_top">
            <img
              class="mx-auto z-20 w-full hidden dark:block transition-transform"
              :class="item.img_class"
              :src="'/img/pages/welcome/' + item.img"
              alt="card"
            >
            <img
              class="mx-auto z-20 w-full dark:hidden transition-transform"
              :class="item.img_class"
              :src="'/img/pages/welcome/light-' + item.img"
              alt="card"
            >
          </template>
          <div
            class="absolute w-full inset-x-0 z-10 pointer-events-none"
            :class="item.img_top ? 'bottom-4' : 'top-4'"
          >
            <div
              class="h-36 w-56 -translate-x-10 translate-y-10 blur-3xl opacity-0 group-hover:translate-x-0 group-hover:translate-y-0 group-hover:opacity-10 dark:group-hover:opacity-30 transition-all mix-blend-overlay bg-gradient-to-r rounded-full from-blue-600 to-blue-400"
            />
          </div>
        </div>
      </div>
    </section>

    <!-- Pricing -->
    <section
      class="max-w-screen-xl bg-dark-100 mt-20 md:mt-40 px-5 xl:px-0 mx-auto rounded-2xl"
    >
      <div class="max-w-[930px] mx-auto">
        <pricing-block />

        <!-- FAQs -->
        <div class="mt-20 block">
          <h3 class="text-3xl sm:text-[40px] font-bold">
            FAQs
          </h3>
          <FAQs />
        </div>
      </div>
    </section>

    <!-- Footer -->
    <airtable-forms-footer />
  </div>
</template>

<script setup>

import FAQs from "~/components/pages/FAQs.vue"

const killerFeatures = [
  {
    subtitle: "Better design",
    svg:
      '<svg class="w-6 h-6" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
      '              <g id="Sparkle">\n' +
      '                <path id="Vector"\n' +
      '                      d="M16.9796 11.5911L12.5444 9.95828L10.9115 5.51961C10.8148 5.25692 10.6399 5.03022 10.4103 4.87008C10.1807 4.70995 9.90755 4.62408 9.62763 4.62408C9.34772 4.62408 9.07454 4.70995 8.84495 4.87008C8.61536 5.03022 8.44042 5.25692 8.34373 5.51961L6.7092 9.95313L2.27052 11.5859C2.00784 11.6826 1.78113 11.8576 1.621 12.0872C1.46086 12.3167 1.375 12.5899 1.375 12.8698C1.375 13.1498 1.46086 13.4229 1.621 13.6525C1.78113 13.8821 2.00784 14.0571 2.27052 14.1538L6.70318 15.7969L8.33599 20.233C8.43269 20.4957 8.60763 20.7224 8.83722 20.8825C9.0668 21.0426 9.33998 21.1285 9.6199 21.1285C9.89982 21.1285 10.173 21.0426 10.4026 20.8825C10.6322 20.7224 10.8071 20.4957 10.9038 20.233L12.5366 15.7977L16.9753 14.1649C17.238 14.0682 17.4647 13.8933 17.6248 13.6637C17.785 13.4341 17.8708 13.1609 17.8708 12.881C17.8708 12.6011 17.785 12.3279 17.6248 12.0983C17.4647 11.8687 17.238 11.6938 16.9753 11.5971L16.9796 11.5911ZM12.0648 14.5078C11.879 14.576 11.7103 14.6838 11.5704 14.8238C11.4304 14.9637 11.3226 15.1324 11.2544 15.3182L9.62162 19.7405L7.99224 15.3148C7.924 15.13 7.81653 14.9621 7.67723 14.8228C7.53793 14.6835 7.3701 14.5761 7.18529 14.5078L2.76295 12.875L7.18529 11.2422C7.3701 11.1739 7.53793 11.0665 7.67723 10.9272C7.81653 10.7879 7.924 10.62 7.99224 10.4352L9.62506 6.01289L11.2579 10.4352C11.3261 10.621 11.4339 10.7897 11.5738 10.9297C11.7137 11.0696 11.8825 11.1774 12.0683 11.2456L16.4906 12.8784L12.0648 14.5078ZM12.3751 3.9375C12.3751 3.75516 12.4475 3.5803 12.5764 3.45136C12.7054 3.32243 12.8802 3.25 13.0626 3.25H14.4376V1.875C14.4376 1.69266 14.51 1.5178 14.6389 1.38886C14.7679 1.25993 14.9427 1.1875 15.1251 1.1875C15.3074 1.1875 15.4823 1.25993 15.6112 1.38886C15.7401 1.5178 15.8126 1.69266 15.8126 1.875V3.25H17.1876C17.3699 3.25 17.5448 3.32243 17.6737 3.45136C17.8026 3.5803 17.8751 3.75516 17.8751 3.9375C17.8751 4.11984 17.8026 4.2947 17.6737 4.42364C17.5448 4.55257 17.3699 4.625 17.1876 4.625H15.8126V6C15.8126 6.18234 15.7401 6.3572 15.6112 6.48614C15.4823 6.61507 15.3074 6.6875 15.1251 6.6875C14.9427 6.6875 14.7679 6.61507 14.6389 6.48614C14.51 6.3572 14.4376 6.18234 14.4376 6V4.625H13.0626C12.8802 4.625 12.7054 4.55257 12.5764 4.42364C12.4475 4.2947 12.3751 4.11984 12.3751 3.9375ZM21.3126 8.0625C21.3126 8.24484 21.2401 8.4197 21.1112 8.54864C20.9823 8.67757 20.8074 8.75 20.6251 8.75H19.9376V9.4375C19.9376 9.61984 19.8651 9.79471 19.7362 9.92364C19.6073 10.0526 19.4324 10.125 19.2501 10.125C19.0677 10.125 18.8929 10.0526 18.7639 9.92364C18.635 9.79471 18.5626 9.61984 18.5626 9.4375V8.75H17.8751C17.6927 8.75 17.5179 8.67757 17.3889 8.54864C17.26 8.4197 17.1876 8.24484 17.1876 8.0625C17.1876 7.88016 17.26 7.7053 17.3889 7.57636C17.5179 7.44743 17.6927 7.375 17.8751 7.375H18.5626V6.6875C18.5626 6.50516 18.635 6.3303 18.7639 6.20136C18.8929 6.07243 19.0677 6 19.2501 6C19.4324 6 19.6073 6.07243 19.7362 6.20136C19.8651 6.3303 19.9376 6.50516 19.9376 6.6875V7.375H20.6251C20.8074 7.375 20.9823 7.44743 21.1112 7.57636C21.2401 7.7053 21.3126 7.88016 21.3126 8.0625Z"\n' +
      '                      fill="currentColor"\n' +
      "                />\n" +
      "              </g>\n" +
      "            </svg>",
    title: "Create beautiful forms.<br> On brand",
    text: "Forms are a reflection of your brand. Don't settle for standard design. Customise our beautiful templates to make your form truly beautiful",
    video: "beautiful.mp4",
  },
  {
    subtitle: "Lightning quick",
    svg:
      '<svg class="inline h-6 w-6" viewBox="0 0 22 22" fill="none"\n' +
      '                 xmlns="http://www.w3.org/2000/svg"\n' +
      "            >\n" +
      "              <path\n" +
      '                d="M18.5446 10.1552C18.5186 10.045 18.4657 9.94296 18.3908 9.85811C18.3158 9.77326 18.2211 9.70823 18.1149 9.6688L13.1641 7.81169L14.4239 1.5099C14.4524 1.36348 14.4326 1.21175 14.3673 1.07761C14.302 0.943478 14.1949 0.83421 14.0621 0.766297C13.9293 0.698385 13.778 0.675514 13.631 0.701136C13.484 0.726757 13.3494 0.799481 13.2474 0.908334L3.62242 11.2208C3.54424 11.3032 3.48769 11.4037 3.45781 11.5132C3.42794 11.6228 3.42566 11.738 3.4512 11.8487C3.47674 11.9593 3.52928 12.0619 3.60415 12.1473C3.67901 12.2327 3.77387 12.2982 3.88023 12.338L8.83281 14.1951L7.5764 20.4901C7.54787 20.6365 7.56774 20.7882 7.63301 20.9223C7.69828 21.0565 7.8054 21.1657 7.93822 21.2337C8.07104 21.3016 8.22234 21.3244 8.3693 21.2988C8.51625 21.2732 8.65089 21.2005 8.75288 21.0916L18.3779 10.7791C18.4546 10.6967 18.51 10.5967 18.5391 10.488C18.5681 10.3792 18.57 10.2649 18.5446 10.1552ZM9.39913 18.3906L10.2989 13.8892C10.3311 13.7295 10.3056 13.5637 10.2269 13.4211C10.1482 13.2785 10.0214 13.1685 9.86921 13.1106L5.32828 11.4047L12.6003 3.61365L11.7014 8.11505C11.6692 8.2747 11.6947 8.44059 11.7734 8.58318C11.8521 8.72577 11.9789 8.83579 12.1311 8.89365L16.6686 10.5952L9.39913 18.3906Z"\n' +
      '                fill="currentColor"\n' +
      "              />\n" +
      "            </svg>",
    title: "Get the submissions directly in your AirTable base",
    text: "Publish your form as a full web page or embed it on your website in a couple of clicks and start receiving the submission in your AirTable base instantly. No code needed.",
    video: "to-airtable.mp4",
  },
  {
    subtitle: "Synchronise in real time",
    svg:
      '<svg class="h-4 w-4" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
      "              <path\n" +
      '                d="M14.9873 13.5162C15.1156 13.645 15.1876 13.8195 15.1876 14.0013C15.1876 14.1831 15.1156 14.3576 14.9873 14.4864C14.8936 14.5784 12.6798 16.75 9 16.75C5.7868 16.75 3.45445 14.825 2.125 13.3254V15.375C2.125 15.5573 2.05257 15.7322 1.92364 15.8611C1.7947 15.9901 1.61984 16.0625 1.4375 16.0625C1.25516 16.0625 1.0803 15.9901 0.951364 15.8611C0.822433 15.7322 0.75 15.5573 0.75 15.375V11.25C0.75 11.0677 0.822433 10.8928 0.951364 10.7639C1.0803 10.6349 1.25516 10.5625 1.4375 10.5625H5.5625C5.74484 10.5625 5.9197 10.6349 6.04864 10.7639C6.17757 10.8928 6.25 11.0677 6.25 11.25C6.25 11.4323 6.17757 11.6072 6.04864 11.7361C5.9197 11.8651 5.74484 11.9375 5.5625 11.9375H2.76437C3.82312 13.2566 5.99219 15.375 9 15.375C12.0938 15.375 13.9964 13.5308 14.0153 13.5119C14.1448 13.3836 14.3199 13.312 14.5022 13.3128C14.6844 13.3136 14.8589 13.3868 14.9873 13.5162ZM16.5625 0.9375C16.3802 0.9375 16.2053 1.00993 16.0764 1.13886C15.9474 1.2678 15.875 1.44266 15.875 1.625V3.67461C14.5455 2.175 12.2132 0.25 9 0.25C5.32016 0.25 3.10641 2.42164 3.01359 2.51359C2.88436 2.64237 2.81158 2.81721 2.81126 2.99964C2.81094 3.18208 2.8831 3.35718 3.01187 3.48641C3.14065 3.61564 3.31549 3.68842 3.49793 3.68874C3.68036 3.68906 3.85546 3.6169 3.98469 3.48813C4.00359 3.46922 5.90625 1.625 9 1.625C12.0078 1.625 14.1769 3.74336 15.2356 5.0625H12.4375C12.2552 5.0625 12.0803 5.13493 11.9514 5.26386C11.8224 5.3928 11.75 5.56766 11.75 5.75C11.75 5.93234 11.8224 6.1072 11.9514 6.23614C12.0803 6.36507 12.2552 6.4375 12.4375 6.4375H16.5625C16.7448 6.4375 16.9197 6.36507 17.0486 6.23614C17.1776 6.1072 17.25 5.93234 17.25 5.75V1.625C17.25 1.44266 17.1776 1.2678 17.0486 1.13886C16.9197 1.00993 16.7448 0.9375 16.5625 0.9375Z"\n' +
      '                fill="currentColor"\n' +
      "              />\n" +
      "            </svg>",
    title: "Update records directly from your form",
    text: "You can decide to allow form users to see and update their previous submissions",
    video: "edit.mp4",
  },
]
</script>

<style lang="scss" scoped>
img {
  outline: 1px solid transparent;
}
</style>
